<template>
	<div class="step_container">
		<el-form ref="firstStepForm" :model="firstStepForm" :rules="rules" :inline="inline" :label-width="labelWidth" :label-position="labelPosition" size="mini">
		  <el-form-item label="关联企业" prop="company_name">
		    <el-autocomplete :trigger-on-focus="false" style="width: 300px;" value-key="name" :debounce="300" v-model="firstStepForm.company_name" :fetch-suggestions="querySearchAsync" @select="handleSelect" placeholder="输入公司名称自动搜索"></el-autocomplete>
		  </el-form-item>
		  <el-form-item label="热门类型">
		    <el-radio-group v-model="firstStepForm.task_species_id" @change="changeHotType($event,1)">
		      <el-radio-button :label="item.id" v-for="(item,index) in typeList.hotTypeList" :key="index">{{item.species_name}}</el-radio-button>
		    </el-radio-group>
		  </el-form-item>
		  <el-form-item label="其他类型">
		    <el-select v-model="firstStepForm.other_id" placeholder="请选择其他类型" @change="changeHotType($event,2)">
		      <el-option :label="item.species_name" :value="item.id" :key="item.id" v-for="(item,index) in typeList.otherTypeList"></el-option>
		    </el-select>
		  </el-form-item>
		  <el-form-item size="large">
        <slot name="handle"></slot>
		  </el-form-item>
		</el-form>
	</div>
</template>

<script>
  import "@/shared/plugins/element"
  import Api from "@/api";
	export default {
		props:{
			//表单元素是并列同行还是独占一行
			inline:{
				type:Boolean,
				default:false
			},
			//表单标签宽度
			labelWidth:{
				type:String,
				default:'85px'
			},
			//表单标签位置
			labelPosition:{
				type:String,
				default:'left'
			},
      //类型
      typeList:{
        type:Object,
        default:()=>{}
      },
			//绑定的表单
			firstStepForm:{
				type:Object,
				default:()=>{}
			},
      //校验规则
      rules:{
      	type:Object,
      	default:()=>{}
      }
		},
		data(){
			return {
				
			}
		},
		methods:{
			// 表单验证
			async submitForm(prop) {
				try {
					return await this.$refs["firstStepForm"].validate();
				} catch (error) {
					return error;
				}
			},
      //更改热门类型
      changeHotType(id,type){
        let obj = {
          id:id,
          type:type
        }
        this.$emit('changeHotType',obj)
      },
      async querySearchAsync(val, cb){
        if(val){
          let params = {
            keywords:val
          }
          try{
            let data = await Api.post.queryCompany(params);
            if(data.length > 0){
              console.log(data)
              data.forEach((item,index) =>{
                item.value = item.name
              })
              cb(data);
            }else{
              cb([{value:'未查到公司信息'}]);
            }
            
          }catch(e){
            //TODO handle the exception
          }
        }
      },
      handleSelect(item){
        this.$emit('handleSelect',item)
      },
		}
	}
</script>

<style scoped="scoped">
  .step_container >>> .el-form-item--mini .el-form-item__error{
    padding-top: 3px!important;
  }
</style>
